import { forwardRef } from 'react';
import { Form, Hint, NativeSelect } from '@heathmont/moon-core-tw';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  errors?: boolean;
  categories: SelectOption[];
  topic?: string;
};

const CategoriesInput = forwardRef<HTMLOptionElement, Props>((props, ref) => {
  const { errors = false, categories, ...inputProps } = props;

  return (
    <Form.Item className="relative z-10 max-w-[616px]" error={errors}>
      <NativeSelect {...inputProps}>
        <Translate id="support.topic" />
        {categories.map((category) => (
          <option ref={ref} value={category.value} key={category.value}>
            {category.value}
          </option>
        ))}
      </NativeSelect>
      {errors && (
        <Hint>
          <Translate id="errors.input.required" />
        </Hint>
      )}
    </Form.Item>
  );
});

export default CategoriesInput;
